import { type ProductListTypeS } from '../../../../../features/ProductList/outbound/share';

export const DEFAULT_FLOATING_BUTTON_RECENT_PRODUCT_OPTION: ProductListTypeS.ProductThumbnailOption = {
  resize_width: 600,
};
